<template>
  <v-row justify="center">
    <v-dialog
      v-model="showing"
      :content-class="'bootstrap-modal-' + modalSize + ' overflow-x-hidden '"
      role="document"
      :persistent="!backdrop"
    >
      <v-row class="bootstrap-modal-wrapper mr-0 ml-0 flex-column">
        <div class="close-spacing">
          <span class="close-button-adjustment" aria-hidden="true" v-show="showClose" @click.stop="hide">&times;</span>
        </div>
        <v-col class="col-12 col-md pt-5">
          <slot></slot>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>
<script>
import tool from '../../../common/js/tool';
export default {
  name: 'BootstrapModal2',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // modal标题
    title: {
      type: String,
      default: ''
    },
    // 点击灰色背景是否关闭弹窗
    backdrop: {
      type: Boolean,
      default: true
    },
    modalSize: {
      // Options: modal-lg, modal-md, modal-sm, modal-xs
      type: String,
      default: ''
    },
    close: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showing: false,
      id:
        'bootstrap_modal' +
        new Date().getTime() +
        '_' +
        Math.random()
          .toString(32)
          .substr(2),
      showCount: 0
    };
  },
  methods: {
    show() {
      this.showing = true;
      if (this.value === false) {
        this.$emit('input', true);
      }
      tool.addClass(document.body, 'modal-open');
      if (window.innerWidth < 992) {
        document.body.style.height = window.innerHeight + 'px';
      }
      this.showCount++;
      if (this.showCount === 1) {
        this.$emit('firstShow');
      }
      this.$emit('onshow');
    },
    hide() {
      this.showing = false;
      if (this.value === true) {
        this.$emit('input', false);
      }
      tool.removeClass(document.body, 'modal-open');
      if (window.innerWidth < 992) {
        document.body.style.height = '';
        document.body.style.overflow = '';
      }
      this.$emit('onhide');
    }
  },
  watch: {
    value(newval) {
      if (newval) {
        this.show();
      } else {
        this.hide();
      }
    },
    showing: function(val) {
      if (!this.showing) {
        this.hide();
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$nextTick(() => {
      this.value && this.show();
    });
  }
};
</script>

<style lang="stylus">
.bootstrap-modal-wrapper{
  border-radius: 10px;
  background-color:white;
}
.v-dialog {
  &.bootstrap-modal-md {
    width: 500px;
  }
  &.bootstrap-modal-lg {
    width: 900px;
  }
  &.bootstrap-modal-sm {
    width: 300px;
  }
}
.close-spacing{
  text-align: end;
  padding: 10px 20px 0px 10px;
}
.close-button-adjustment{
  color:#0c0c0c;
  font-size:1.4em;
  cursor: pointer;
}
</style>
